import { availableLanguages } from "@/i18n";

export function detectLanguageFromUrl() {
    const params = new URLSearchParams(window.location.search)
    const lang = params.get('lang')
    if (lang && availableLanguages.includes(lang)) {
        return lang
    }
    return null
}
